import React from "react"
import { Image } from "@warp/types/product"
import { ZoomIcon } from "./ZoomIcon"
import { buildSrcsetString, getLastSrcsetUrl } from "@warp/utilities/images"
import Badge from "../Badges/Badge"

type PropType = {
  image: Image | Pick<Image, "srcset" | "alt">
  toggleZoom: React.MouseEventHandler<HTMLButtonElement | HTMLImageElement>
  width?: string
  height?: string
  sizes?: string
  className?: string
  hideBadge?: boolean
}

const ZoomableImage: React.FC<PropType> = ({
  image,
  toggleZoom: originalToggleZoom,
  sizes = "100vw",
  width = "100%",
  height = "",
  className = "zoom-container",
  hideBadge = false
}) => {
  const toggleZoom: React.MouseEventHandler<
    HTMLButtonElement | HTMLImageElement
  > = (event) => {
    originalToggleZoom(event)
  }

  return (
    <div className={className}>
      <img
        src={getLastSrcsetUrl(image.srcset)}
        srcSet={buildSrcsetString(image.srcset)}
        alt={image.alt}
        sizes={sizes}
        onClick={toggleZoom}
        width={width}
        height={height}
        loading="lazy"
      />
      {!hideBadge && (
        <button className="zoom-open" onClick={toggleZoom}>
          <Badge badge={{ key: "zoom", value: "Zoom" }}>
            <ZoomIcon />
          </Badge>
        </button>
      )}
    </div>
  )
}

export default ZoomableImage
